import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { emitToast } from "../components/Toast";
import s from "./Reviewer.module.css";

const STATUS: Record<string, string> = { sent: "Enviado", opened: "Aberto", used: "Concluído", expired: "Expirado" };

export function Invites({ email }: { email: string }) {
  const [assessments, setAssessments] = useState<any[]>([]);
  const [assessmentId, setAssessmentId] = useState("");
  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [phone, setPhone] = useState("");
  const [invites, setInvites] = useState<any[]>([]);

  async function load() {
    const [{ data: a }, { data: inv }] = await Promise.all([
      supabase.from("rec_assessments").select("id, title").order("title"),
      supabase.from("rec_invites").select("*").order("created_at", { ascending: false }).limit(50),
    ]);
    setAssessments(a || []);
    if (a && a[0] && !assessmentId) setAssessmentId(a[0].id);
    setInvites(inv || []);
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  function linkFor(token: string) { return `${window.location.origin}/t/${token}`; }
  async function copy(token: string) {
    try { await navigator.clipboard.writeText(linkFor(token)); emitToast("success", "Link copiado."); }
    catch { emitToast("info", linkFor(token)); }
  }

  async function create() {
    if (!assessmentId || !name) { emitToast("warning", "Escolha a vaga e informe o nome."); return; }
    const { data, error } = await supabase.from("rec_invites").insert({
      assessment_id: assessmentId, candidate_name: name, candidate_email: mail || null,
      candidate_phone: phone || null, created_by: email,
    }).select().single();
    if (error) { emitToast("error", error.message); return; }
    setName(""); setMail(""); setPhone("");
    await copy(data.token);
    load();
  }

  return (
    <div className={s.page}>
      <h2>Convites</h2>
      <div className="card" style={{ padding: "var(--s-4)", display: "flex", flexDirection: "column", gap: "var(--s-3)", maxWidth: 560 }}>
        <div className={s.toolbar}>
          <select value={assessmentId} onChange={(e) => setAssessmentId(e.target.value)} style={{ flex: 1 }}>
            {assessments.map((a) => <option key={a.id} value={a.id}>{a.title}</option>)}
          </select>
        </div>
        <input className="" placeholder="Nome do candidato" value={name} onChange={(e) => setName(e.target.value)} style={inputStyle} />
        <input placeholder="E-mail (opcional)" value={mail} onChange={(e) => setMail(e.target.value)} style={inputStyle} />
        <input placeholder="WhatsApp (opcional)" value={phone} onChange={(e) => setPhone(e.target.value)} style={inputStyle} />
        <button className="btn btn-primary" onClick={create}>Gerar convite e copiar link</button>
        <p className="dim" style={{ fontSize: 12 }}>O link abre direto a prova no celular do candidato. Cole no WhatsApp dele.</p>
      </div>

      <h3>Convites recentes</h3>
      <div className={s.scrollx}>
        <table className={s.table}>
          <thead><tr><th>Candidato</th><th>Status</th><th>Criado</th><th>Link</th></tr></thead>
          <tbody>
            {invites.map((iv) => (
              <tr key={iv.id}>
                <td>{iv.candidate_name || "—"}</td>
                <td><span className="badge badge-neutral">{STATUS[iv.status] || iv.status}</span></td>
                <td className="dim">{new Date(iv.created_at).toLocaleString("pt-BR")}</td>
                <td><div className={s.copyrow}><code>{linkFor(iv.token)}</code><button className="btn btn-ghost" style={{ padding: "4px 10px" }} onClick={() => copy(iv.token)}>copiar</button></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  background: "var(--ink-1)", border: "1px solid var(--ink-3)", borderRadius: "var(--r-md)",
  color: "var(--cream-1)", padding: "10px", fontSize: 14,
};
